import { TableContainer, Table, TableBody, TableRow, TableCell, Typography } from "@mui/material";

import { WSTestingProductPairValue } from '../../types/WSTestingData';

export const WSTestingRecordPairingTable = ({ productPairData }: { productPairData: WSTestingProductPairValue | null }) => {

    let clientStr = 'Please select a client product!';
    let serverStr = 'Please select a server product!';

    if (productPairData && productPairData.clientProduct) {
        clientStr = `${productPairData.clientProduct.companyName} - ${productPairData.clientProduct.productName} ${productPairData.clientProduct.productVersion ?? ""}`;
    }
    if (productPairData && productPairData.serverProduct) {
        serverStr = `${productPairData.serverProduct.companyName} - ${productPairData.serverProduct.productName} ${productPairData.serverProduct.productVersion ?? ""}`;
    }

    return <TableContainer>
        <Table>
            <TableBody>
                <TableRow>
                    <TableCell><Typography variant={'bold'}>{productPairData?.combinationConsumer ?? "Client"}</Typography></TableCell>
                    <TableCell>{(clientStr)}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell><Typography variant={'bold'}>{productPairData?.combinationProvider ?? "Server"}</Typography></TableCell>
                    <TableCell>{serverStr}</TableCell>
                </TableRow>
                <TableCell><Typography variant={'bold'}>Interface</Typography></TableCell>
                <TableCell>{productPairData?.interfaceName ?? ""}</TableCell>
            </TableBody>
        </Table>
    </TableContainer>
}